import type { Correction } from "@/queries/formality-request";
import { cn } from "@/utils/theme";
import { Badge, Icon } from "@elaniintc/goes-design-system";

export default function ReadOnlyCorrection({
  fieldId,
  correction,
  onOpenModal,
}: Readonly<{
  fieldId?: string;
  correction: NonNullable<Correction["field_corrections"]>[number];
  onOpenModal: (id: string) => void;
}>) {
  const isDenied = correction.status === "DENIED";
  const hasComments = correction.comments && correction.comments.length > 0;

  return (
    <div className="relative">
      {isDenied && hasComments && (
        <Badge
          size="xs"
          variant="danger"
          fill="solid"
          className="rounded-full size-5 flex items-center justify-center absolute -top-3 -right-2 cursor-pointer"
          onClick={() => onOpenModal(fieldId ?? "")}
        >
          <Icon name="comment" type="fas" className="text-2xs text-on-solid" />
        </Badge>
      )}
      <Badge
        shape="square"
        size="sm"
        variant={isDenied ? "danger" : "success"}
        className="size-6 flex items-center justify-center rounded-lg cursor-default"
      >
        <Icon
          name={isDenied ? "times" : "check"}
          type="fas"
          className={cn(
            "text-xs",
            isDenied ? "text-danger-quiet" : "text-success-quiet",
          )}
        />
      </Badge>
    </div>
  );
}
